import * as React from 'react';
import Griddle, { RowDefinition, ColumnDefinition, GriddlePageProperties, GriddleSortKey, plugins } from 'griddle-react';
import * as GridConfig from '../../config/grid-config';
import './DataGrid.css';


interface DataGridProps {
    entities: any[];
    columns: { id: string, title?: string, width?: string, customComponent?: ({ value }: any) => JSX.Element }[];
    pageSize?: number;
    sortProperties?: GriddleSortKey[];
}

interface DataGridState {
    pageProperties: GriddlePageProperties;
    sortProperties?: GriddleSortKey[];
}

export class DataGrid extends React.Component<DataGridProps, DataGridState> {
    // private pageProperties: GriddlePageProperties = {
    //     currentPage: 1,
    //     pageSize: 20,
    // };

    constructor(props: DataGridProps) {
        super(props);

        // if (this.props.pageSize) {
        //     this.pageProperties.pageSize = this.props.pageSize;
        // }

        this.state = {
            pageProperties: {
                currentPage: 1,
                pageSize: this.props.pageSize ? this.props.pageSize : 20
            },
            sortProperties: this.props.sortProperties
        };
    }

    componentWillReceiveProps(nextProps: any) {
        if (this.props.pageSize !== nextProps.pageSize) {
            this.setState({
                pageProperties:
                    Object.assign(
                        {},
                        this.state.pageProperties,
                        { pageSize: nextProps.pageSize ? nextProps.pageSize : 20 }
                    )
            });
        }
    }

    public render() {
        const { entities, columns } = this.props;
        const { pageProperties, sortProperties } = this.state;

        return (
            <Griddle data={entities} plugins={[plugins.LocalPlugin]} styleConfig={GridConfig.gridStyle} pageProperties={pageProperties} sortProperties={sortProperties} components={{ Layout: GridConfig.gridLayout }}>
                <RowDefinition>
                    {columns.map((column, index) => <ColumnDefinition key={`column-${index}`} {...column} />)}
                </RowDefinition>
            </Griddle>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/datagrid/DataGrid.tsx